'use client'

import { memo, useCallback, useRef } from 'react'
import { useNotebook } from '@/lib/notebook/core/store'
import BlockHost from '@/lib/notebook/Blocks/shared/BlockHost'

function SectionRendererInner({ section, structural = false }) {
  const locked = useNotebook((s) => s.locked)
  const updateSection = useNotebook((s) => s.updateSection)
  const sectionIdRef = useRef(section.id)
  sectionIdRef.current = section.id

  const onChange = useCallback(
    (data) => {
      if (locked) return
      updateSection(sectionIdRef.current, data)
    },
    [locked, updateSection],
  )

  return (
    <BlockHost
      sectionId={section.id}
      type={section.type}
      data={section.data ?? {}}
      onChange={onChange}
      locked={locked}
      structural={structural}
    />
  )
}

function sectionPropsEqual(prev, next) {
  const a = prev.section
  const b = next.section
  return (
    a.id === b.id &&
    a.type === b.type &&
    a.data === b.data &&
    prev.structural === next.structural
  )
}

export default memo(SectionRendererInner, sectionPropsEqual)
